import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'hfc-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {
  @Input()
  public value: number;

  @Input()
  showValue = true;

  @Input()
  unit = '%';

  @Input()
  radius = true;

  constructor() {}

  ngOnInit() {}
}
